export default __webpack_public_path__ + "static/Long-6cb0ae4d6f80df7d96f79da8fcd83bbd.webp";